import { Injectable } from "@angular/core";

import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { PagingRequest } from "../../models/domains/paginator/paging-request";
import { ProductCategory } from "../../models/domains/pbm/Benefit/product-category";
import { ProductSubtype } from "../../models/domains/pbm/Benefit/product-subtype";
import { ProductType } from "../../models/domains/pbm/Benefit/product-type";
import { ProductRepository } from "../../repositories/pbm/product.repository";

@Injectable({ providedIn: "root" })
export class ProductService {
  constructor(private productRepository: ProductRepository) {}

  public async searchProductBy(pagingRequest: PagingRequest): Promise<PageableResult> {
    return await this.productRepository.searchProductBy(pagingRequest);
  }

  public async getProductTypes(): Promise<Array<ProductType>> {
    return await this.productRepository.getProductTypes();
  }

  public async getProductSubtypeByType(typeKey: string): Promise<Array<ProductSubtype>> {
    return this.productRepository.getProductSubtypeByType(typeKey);
  }

  public async getProductCategoryList(): Promise<Array<ProductCategory>> {
    return this.productRepository.getProductCategoryList();
  }
}
